<template>
  <v-layout
    :loading="loading"
    :background="false"
  >
    <div
      v-if="article"
      class="w-screen pb-20 overflow-x-hidden"
    >
      <v-images-swiper :article="article" />

      <div class="container max-w-2xl">
        <h1 class="title-1 mb-5">
          {{ article.title }}

          <span
            class="float-right cursor-pointer"
            @click="copyArticleLink"
          >
            <i class="mdi mdi-content-copy" />
          </span>
        </h1>

        <div class="flex flex-wrap mb-6">
          <div
            v-for="cluster in article.clusters"
            :key="cluster.id"
            class="p-1"
          >
            <router-link
              :to="`/news-feed/${cluster.id}/articles`"
              class="inline-block px-2 py-0.5 text-sm font-medium rounded text-primary-400 bg-primary-50"
            >
              {{ cluster.title }}
            </router-link>
          </div>
        </div>

        <div
          class="lg:prose-xl mb-10 prose"
          v-html="article.body"
        />

        <v-claim-read
          v-if="article.can.claim_read_points"
          class="mb-10"
          :article="article"
          :reading-time="readingTime"
          @success="onClaimSuccess($event)"
        />

        <v-claim-c2a
          v-if="article.can.claim_c2a_points && article.c2a_text && article.c2a_url && article.c2a_points_number"
          :article="article"
          :reading-time="readingTime"
          @success="onClaimSuccess($event)"
        />

        <div class="mb-10" />

        <router-link
          :to="'/news-feed/'+$route.query.provenance_cluster_id+'/articles'"
        >
          <v-button
            type="button"
            class="btn btn-btn-white-outline w-full"
          >
            <i class="mdi mdi-arrow-left mr-2" />
            Back to {{ $route.query.provenance_cluster_title }}
          </v-button>
        </router-link>

        <transition
          enter-active-class="transition duration-200 ease-out"
          enter-from-class="md:translate-y-3 -translate-y-3 opacity-0"
          enter-to-class="opacity-500 translate-200"
          leave-active-class="transition duration-200 ease-in delay-100"
          leave-from-class="translate-y-0 opacity-100"
          leave-to-class="md:translate-y-3 -translate-y-3 opacity-0"
        >
          <div
            v-if="showSuccessModal"
            class="fixed inset-0 z-10 w-full h-full"
          >
            <div
              class="opacity-90 absolute inset-0 w-full h-full bg-white"
              @click="showSuccessModal = false"
            />
            <div class="w-full h-full overflow-y-auto">
              <div class="md:py-20 flex items-center justify-center w-full py-6">
                <div class="card relative w-full max-w-sm shadow-xl">
                  <h2 class="title mb-5 text-center">
                    Congrats!
                  </h2>

                  <div v-if="$laravel.user.company != null && achievements != null">
                    <v-offset
                      :achievements="achievements"
                      :show-link="false"
                    />
                  </div>

                  <div v-if="$laravel.user.company != null && milestones != null">
                    <v-next-offset
                      :milestones="milestones"
                      :show-link="false"
                    />
                  </div>

                  <div v-if="achievements != null">
                    <v-planted-trees :achievements="achievements" />
                  </div>

                  <div v-if="milestones != null">
                    <v-next-tree
                      :milestones="milestones"
                      :show-tree-icon="false"
                    />
                  </div>

                  <button
                    type="button"
                    class="btn btn-primary w-full mt-5"
                    @click="showSuccessModal = false"
                  >
                    Ok, got it!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </v-layout>
</template>
<script>
import claimRead from "./actions/claim-read.vue";
import claimC2a from "./actions/claim-c2a.vue";
import imagesSwiper from "./images-swiper.vue";
import plantedTrees from "../../includes/achievements/planted-trees.vue";
import nextTree from "../../includes/milestones/next-tree.vue";
import offset from "../../includes/achievements/offset.vue";
import nextOffset from "../../includes/milestones/next-offset.vue";
export default {
  name: "v-article-show",
  components: {
    "v-claim-read": claimRead,
    "v-claim-c2a": claimC2a,
    "v-planted-trees": plantedTrees,
    "v-next-tree": nextTree,
    "v-images-swiper": imagesSwiper,
    "v-offset": offset,
    "v-next-offset": nextOffset
  },
  data() {
    return {
      loading: false,
      article: null,
      readingTime: 0,
      counterId: null,
      achievements: null,
      milestones: null,
      showSuccessModal: false,
    };
  },
  watch: {
    "$route.params.article" () {
      if (this.$route.params.article) {
        this.fetch();
        this.readingTime = 0 ;
        this.setCounterId();
      }
    }
  },
  created() {
    this.fetch();
    this.setCounterId();
  },
  beforeUnmount() {
    clearInterval(this.counterId);
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http.get(this.$laravel.route("api.articles.show",{article: this.$route.params.article}))
        .then((response) => {
          this.article = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    countReadingTime() {
      this.readingTime ++;
    },
    setCounterId() {
      this.counterId = setInterval(this.countReadingTime,1000);
    },
    onClaimSuccess(response) {
      this.showSuccessModal = true;
      this.achievements = response.data.achievements;
      this.milestones = response.data.milestones;
      this.fetch();
    },
    copyArticleLink() {
      if (
        typeof navigator === "undefined" ||
        !navigator.clipboard ||
        !navigator.clipboard.writeText
      ) {
        throw new Error("Clipboard API not available in this browser");
      }

      let url = new URL(window.location.href);

      navigator.clipboard.writeText(url).then(
        () => {
          this.$notificator.success("Article link copied successfully");
        }
      );
    }
  }
};
</script>
